import styled, { css } from 'styled-components';
import { flexColumn, flexCenterVertical } from '@stylesheets/helpers';

export const TitleRow = styled.div`
  ${flexCenterVertical};
  flex-wrap: wrap;
  min-width: 0;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level2};
  `}
`;

export const ProcessName = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    font-weight: ${font.labelLarge.fontWeight};
    color: ${colors.onSurface};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 320px;
  `}
`;

export const RunNumber = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.labelSmall.fontSize};
    line-height: ${font.labelSmall.lineHeight};
    font-variant-numeric: tabular-nums;
    color: ${colors.onSurfaceVariant};
  `}
`;

export const TestRunChip = styled.span`
  display: inline-block;

  ${({ theme: { font, colors, spacing, borderRadius } }) => css`
    font-size: ${font.labelSmall.fontSize};
    font-weight: ${font.labelSmall.fontWeight};
    letter-spacing: 0.04em;
    padding: 1px ${spacing.level2};
    border-radius: ${borderRadius.small};
    background: ${colors.secondaryContainer};
    color: ${colors.onSecondaryContainer};
  `}
`;

export const SubtitleRow = styled.div`
  ${flexColumn};
  gap: 2px;
`;

export const StatusPill = styled.span<{ $tone: 'neutral' | 'success' | 'warning' | 'danger' }>`
  display: inline-flex;
  text-transform: capitalize;

  ${({ theme: { font, spacing, borderRadius } }) => css`
    font-size: ${font.labelSmall.fontSize};
    font-weight: ${font.labelSmall.fontWeight};
    letter-spacing: 0.04em;
    padding: 2px ${spacing.level2};
    border-radius: ${borderRadius.small};
  `}

  // The status colour is the cascade winner so the design tokens land
  // even though the base styles above set typography first.
  ${({ theme: { colors }, $tone }) => {
    switch ($tone) {
      case 'success':
        return css`background: ${colors.primaryContainer}; color: ${colors.onPrimaryContainer};`;
      case 'warning':
        return css`background: ${colors.secondaryContainer}; color: ${colors.onSecondaryContainer};`;
      case 'danger':
        return css`background: ${colors.errorContainer}; color: ${colors.onErrorContainer};`;
      case 'neutral':
      default:
        return css`background: ${colors.surfaceContainerHighest}; color: ${colors.onSurfaceVariant};`;
    }
  }}
`;
